import Card from "@mui/material/Card";
import borders from "assets/theme/base/borders";
import PropTypes from "prop-types";
import { useState } from "react";

export default function CartoonCard({
  color = "#ff4e50",
  secondaryColor = "#f9d423",
  tilt = false, // Default: No tilt
  baseTileAngle = -2, // Starting tilt angle
  endTiltAngle = 3, // Ending tilt angle
  children,
  sx,
}) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Card
      sx={{
        // maxWidth: 600,
        textAlign: "center",
        p: 8,
        borderRadius: borders.borderRadius.xl,
        boxShadow: isHovered ? "12px 12px 0px rgba(0,0,0,0.4)" : "8px 8px 0px rgba(0,0,0,0.3)",
        background: `linear-gradient(135deg, ${color}, ${secondaryColor})`,
        border: "4px solid black",
        transform:
          isHovered && tilt
            ? "rotate(" + endTiltAngle + "deg) scale(1.05)"
            : tilt
            ? "rotate(" + baseTileAngle + "deg)"
            : "rotate(0deg)",
        transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
        ...sx,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >

      {/* Custom Children */}
      {children && <>{children}</>}
    </Card>
  );
}

// Default Props
CartoonCard.defaultProps = {
  tilt: false,
  tiltAngle: 3,
  color: "#ff4e50",
};

// // Prop Type Checking
// CartoonCard.propTypes = {
//   title: PropTypes.string.isRequired,
//   description: PropTypes.string.isRequired,
//   buttons: PropTypes.array,
//   color: PropTypes.string,
//   tilt: PropTypes.bool,
//   tiltAngle: PropTypes.number,
//   children: PropTypes.node,
//   image: PropTypes.string,
// };
